import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromMonitoreoModel from './monitoreo.model';

export const selectMonitoreoState = createFeatureSelector<fromMonitoreoModel.MonitoreoState>(
  fromMonitoreoModel.monitoreoFeatureKey
);


// COM Hora actualización *******
export const selectHora = createSelector(
  selectMonitoreoState,
  (state: fromMonitoreoModel.MonitoreoState) => state.hora);

// COM Contador de apertura Movil filtro *******
export const selectContador = createSelector(
  selectMonitoreoState,
  (state: fromMonitoreoModel.MonitoreoState) => state.contador);




